/**
 * The CMSBlockSplit component
 */
import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "reactstrap";
import ResponsivePicture from "../../ResponsivePicture";
import LazyLoad from "react-lazyload";

/**
 * Stateless react component to render the CMSBlockSplit component
 * @param {Object} props the props passed to the page.
 */
const CMSBlockSplit = (props, context) => {
  const { cmsBlock, invert, small } = props;
  // Since Teasers are very small we only take the smalest image to save loading time.
  var imgSrcs = "";
  var webpImgSrcs = "";
  try {
    var lastImg = cmsBlock.image[cmsBlock.image.length - 1];
    imgSrcs = `${lastImg.url}`;
    webpImgSrcs = `${lastImg.webp_url}`;
  } catch (e) {
    console.log("no image url found");
  }
  const imgCol = small ? 3 : 6;
  const contentCol = small ? 9 : 6;

  return (
    <div className="cmsblock__split">
      <Row>
        <Col
          lg={{ size: imgCol, order: invert ? "last" : "first" }}
          xs={small ? imgCol : 12}
          className="text-center align-self-center"
        >
          {lastImg && (
            <div className="px-5">
              <LazyLoad>
                <ResponsivePicture
                  mediumData={{
                    url: imgSrcs,
                    webp_url: webpImgSrcs,
                    metadata: {
                      width: 640,
                      height: 640,
                    },
                  }}
                  className="w-100"
                  altTitle={cmsBlock.title}
                />
              </LazyLoad>
            </div>
          )}
        </Col>
        <Col
          lg={contentCol}
          xs={small ? contentCol : 12}
          className="py-2 align-self-center"
        >
          {cmsBlock.title && <h2 className="text-left">{cmsBlock.title}</h2>}
          {cmsBlock.subtitle && <h3 className="h5">{cmsBlock.subtitle}</h3>}
          {cmsBlock.content && (
            <div
              className="text-big"
              dangerouslySetInnerHTML={{ __html: cmsBlock.content }}
            />
          )}
          {cmsBlock.primary_button_title && cmsBlock.primary_button_target && (
            <a
              href={cmsBlock.primary_button_target}
              className="btn btn-primary mr-4"
            >
              {cmsBlock.primary_button_title}
            </a>
          )}
          {cmsBlock.secondary_button_title &&
            cmsBlock.secondary_button_target && (
              <a
                href={cmsBlock.secondary_button_target}
                className="btn btn-link"
              >
                {cmsBlock.secondary_button_title}
              </a>
            )}
        </Col>
      </Row>
    </div>
  );
};

/** define proptypes for the form */
CMSBlockSplit.propTypes = {
  /** the item */
  cmsBlock: PropTypes.object.isRequired,
};

/**  define proptype for the 'translation' function  */
CMSBlockSplit.contextTypes = {
  t: PropTypes.func,
};
export default CMSBlockSplit;
